import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Router, Route, Switch, Link, useHistory } from "react-router-dom";
import * as actions from "../../../../store/actions/index";
import clsx from "clsx";
import { useLocation } from "react-router-dom";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Badge from "@material-ui/core/Badge";
import AccountCircle from "@material-ui/icons/AccountCircle";
import NotificationsIcon from "@material-ui/icons/Notifications";
import DashboardIcon from "@material-ui/icons/Dashboard";
import WarningIcon from "@material-ui/icons/Warning";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import HistoryIcon from "@material-ui/icons/History";
import AssessmentIcon from "@material-ui/icons/Assessment";
import Alarm from "@material-ui/icons/Alarm";
import SettingsIcon from "@material-ui/icons/Settings";
import DeviceHubIcon from "@material-ui/icons/DeviceHub";
import SettingsApplicationsIcon from "@material-ui/icons/SettingsApplications";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import SpeedIcon from "@material-ui/icons/Speed";
import EditAttributesIcon from "@material-ui/icons/EditAttributes";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import LocalHospital from "@material-ui/icons/LocalHospital";
import NotesIcon from "@material-ui/icons/Notes";
import HelpIcon from "@material-ui/icons/Help";
import WatchIcon from "@material-ui/icons/Watch";
import GroupWorkIcon from "@material-ui/icons/GroupWork";
import Group from "@material-ui/icons/Group";
import MapIcon from "@material-ui/icons/Map";
import Logo from "../../../Logo/Logo";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";
import Aux from "../../../../hoc/Auxiliary";
import Home from "../../../Home/Home";
import ManagementUsers from "../../../UserManagement/ManagementUsers";
import EndUsers from "../../../EndUser/EndUsers";
import Maps from "../../../Maps/BigMap/BigMap";
import MyProfile from "../../../UserManagement/MyProfile";
import Snackbar from "@material-ui/core/Snackbar";
import { Alert } from "@material-ui/lab";
import CreateManagementUser from "../../../UserManagement/CreateManagementUser";
import UserLogging from "../../../UserManagement/UserLogging";
import AssignedAlerts from "../../../Alerts/AssignedAlerts";
import ClosedAlerts from "../../../Alerts/ClosedAlerts";
import OpenAlerts from "../../../Alerts/OpenAlerts";
import AllAlertsTakeOver from "../../../Alerts/AllAlertsTakeOver";
import LocationMap from "../../../Alerts/LocationMap";
import Device from "../../../Devices/Device";
import AddEndUser from "../../../EndUser/AddEndUser";
import EditEndUser from "../../../EndUser/EditEndUser";
import AlertsStatus from "../../../Status/AlertsStatus";
import RiskIndicators from "../../../Status/RiskIndicators";
import Devices from "../../../Devices/Devices";
import SmartBandValues from "../../../Devices/SmartBandValues";
import { UserStats } from "../../../UserStats/UserStats";
import { AlarmStats } from "../../../AlarmStats/AlarmStats";
import EditManagementUser from "../../../UserManagement/EditManagementUser";
import "./Sidebar.css";
import AlertTakeOver from "../../../Alerts/AlertTakeOver";
import PrintForm from "../../../Forms/PrintForm";
import authgetUser from "../../../../services/auth.getUser";
import jwt_decode from "jwt-decode";
import AlertSnackbar from "../../../AlertSnackbar/alertSnackbar";
import nextGenarationBanner from "../../../../assets/images/next-generation-banner.jpg";
import endPoints from "../../../../shared/endPoints.json";


const drawerWidth = 400;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  secondLevelNested: {
    paddingLeft: theme.spacing(6),
  },
  thirdLevelNested: {
    paddingLeft: theme.spacing(8),
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: "#fff",
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
  sectionDesktop: {
    display: "flex",
    position: "absolute",
    right: "100px",
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    backgroundColor: "#015882",
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
    backgroundColor: "#015882",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    color: "white",
  },
  grow: {
    flexGrow: 1,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(1),
    backgroundColor: "#fff",
    marginTop: "30px",
  },
  previousPageButton: {
    position: "absolute",
    right: "60px",
    top: "110%",
  },
}));

function MiniDrawer(props) {
  const {
    setOpenCount,
    setPendingCount,
    pointsStore,
    editMapState,
    isAuth,
    openCount,
    pendingCount,
    reloadCountFlag,
  } = props;


  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [openFirstNested, setFirstOpenNested] = useState(false);
  const [openSecondNested, setSecondOpenNested] = useState(false);
  const [openThirdNested, setThirdOpenNested] = useState(false);
  const [openFourthNested, setFourthOpenNested] = useState(false);
  const [openFifthNested, setFifthOpenNested] = useState(false);

  let history = useHistory();
  const [openPopup, setOpenPopup] = useState(true);
  const location = useLocation();

  useEffect(() => {
    refreshAlarms();
  }, [reloadCountFlag]);

 

  useEffect(() => {
    const interval = setInterval(() => {
      setOpenPopup(true);
    }, 300000);
    return () => clearInterval(interval);
  }, []);

  
  const refreshAlarms = () => {
    let cntOpen = 0;
    let cntAssigned = 0;
    if (pointsStore) {
      pointsStore.map((point) => {
        if (point.alarms.length > 0) {
          point.alarms.map((alarm) => {
            if (alarm.statusId === 1) cntOpen++;
            if (alarm.statusId === 2) cntAssigned++;
          });
        }
      });
      setOpenCount(cntOpen);
      setPendingCount(cntAssigned);
    }
  };

  const notify = () => {
    return (
      <div>
        <Snackbar
          open={openPopup}
          autoHideDuration={6000}
          onClose={handleClose}
        >
          <Alert
            icon={false}
            action={
              ((
                <IconButton
                  className="WhiteIcons"
                  onClick={() => {
                    history.push("/open-alerts");
                    handleClose();
                  }}
                >
                  <WarningIcon />
                </IconButton>
              ),
                (
                  <IconButton
                    className="WhiteIcons"
                    onClick={() => {
                      history.push("/open-alerts");
                      handleClose();
                    }}
                  >
                    <WarningIcon />
                  </IconButton>
                ))
            }
            variant="filled"
            onClose={handleClose}
            severity="warning"
          >
            Έχετε {openCount} ανοιχτές ειδοποιήσεις
          </Alert>
        </Snackbar>
      </div>
    );
  };


  useEffect(() => {
    if (history.location.pathname !== '/smart-band-values' && history.location.pathname !== '/add-end-user') {
      localStorage.removeItem("endUserData");
    }
    if(history.location.pathname !== "/alert-take-over" && history.location.pathname !== "/all-alerts-takeover"){
      localStorage.removeItem("incidentΗandlerΙnformation")
    }
  });


  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenPopup(false);
  };

  const setLogout = () => {
    editMapState({
      pointsStore: null,
    });
    localStorage.removeItem("user");
    props.authorize(false);
  };

  const handleFirstClick = () => {
    setFirstOpenNested(!openFirstNested);
  };

  const handleSecondClick = () => {
    setSecondOpenNested(!openSecondNested);
  };

  const handleThirdClick = () => {
    setThirdOpenNested(!openThirdNested);
  };

  const handleFourthClick = () => {
    setFourthOpenNested(!openFourthNested);
  };

  const handleFifthClick = () => {
    setFifthOpenNested(!openFifthNested);
  };


  const getTheUser = authgetUser();
  const decodedToken = jwt_decode(getTheUser.accessToken);
  const roleDescription = decodedToken.role;

  const setProfile = () => {
    history.push({
      pathname: "/my-profile",
      selected: decodedToken.unique_name,
    });
  };

  const openAlarmView = () => {
    history.push("/open-alerts");
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setFirstOpenNested(false);
    setSecondOpenNested(false);
    setThirdOpenNested(false);
    setFourthOpenNested(false);
    setFifthOpenNested(false);
    setOpen(false);
  };

  if (isAuth) {
    return (
      <div className={classes.root}>
        {openPopup ? notify() : null}
        <CssBaseline />
        <AppBar
          position="fixed"
          className={clsx(classes.appBar, {
            [classes.appBarShift]: open,
          })}
        >
          {location.pathname !== "/" ? (
            <Aux>
              <Button
                variant="contained"
                color="primary"
                className={classes.previousPageButton}
                onClick={() => history.goBack()}
              >
                <ArrowBackIcon />
                Επιστροφη
              </Button>
            </Aux>
          ) : null}
          <Toolbar>
            <IconButton
              className="WhiteIcons"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
            >
              <MenuIcon className="WhiteIcons" />
            </IconButton>
            <Typography className={classes.title} variant="h6" noWrap>
              <Logo />
            </Typography>
            <div className="header-banner-container">
              <img src={nextGenarationBanner} alt="Next Generation Header Banner" className="header-banner-image" onClick={() => window.open(endPoints.NEXTGENERATION)} />
            </div> 
            <div className={classes.sectionDesktop}>
              <IconButton
                className="WhiteIcons"
                aria-label="Σύνολο ανοιχτών ειδοποιήσεων"
                color="inherit"
              >
                <Badge badgeContent={openCount} color="secondary">
                  <NotificationsActiveIcon onClick={openAlarmView} />
                </Badge>
              </IconButton>
              <IconButton
                className="WhiteIcons"
                aria-label="account of current user"
                aria-controls="primary-search-account-menu"
                aria-haspopup="true"
                color="inherit"
              >
                <AccountCircle onClick={setProfile} />
              </IconButton>
              <IconButton
                className="WhiteIcons"
                aria-label="logout"
                aria-haspopup="true"
                color="inherit"
              >
                <ExitToAppIcon onClick={setLogout} />
              </IconButton>
            </div>
          </Toolbar>
        </AppBar>
        <Router history={history}>
          <Drawer
            variant="permanent"
            className={clsx(classes.drawer, {
              [classes.drawerOpen]: open,
              [classes.drawerClose]: !open,
            })}
            classes={{
              paper: clsx({
                [classes.drawerOpen]: open,
                [classes.drawerClose]: !open,
              }),
            }}
          >
            <div className={classes.toolbar}>
              <IconButton onClick={handleDrawerClose}>
                {theme.direction === "rtl" ? (
                  <ChevronRightIcon />
                ) : (
                  <ChevronLeftIcon />
                )}
              </IconButton>
            </div>
            <Divider />
            <List>
              <ListItem button component={Link} to="/">
                <Tooltip title="Πίνακας Ελέγχου">
                  <ListItemIcon>
                    <DashboardIcon className="WhiteIcons" />
                  </ListItemIcon>
                </Tooltip>
                <ListItemText className="WhiteIcons">
                  Πίνακας Ελέγχου
                </ListItemText>
              </ListItem>
              {/* Εδω ξεκινάνε τα renders βάσει του ρόλου */}
              <ListItem button component={Link} to="/maps">
                <Tooltip title="Χάρτης">
                  <ListItemIcon>
                    <MapIcon className="WhiteIcons" />
                  </ListItemIcon>
                </Tooltip>
                <ListItemText className="WhiteIcons">Χάρτης</ListItemText>
              </ListItem>
              <ListItem button onClick={handleFirstClick}>
                <Tooltip title="Ειδοποιήσεις">
                  <ListItemIcon>
                    <Badge
                      badgeContent={openCount + pendingCount}
                      color="secondary"
                    >
                      <WarningIcon className="WhiteIcons" />
                    </Badge>
                  </ListItemIcon>
                </Tooltip>
                <ListItemText className="WhiteIcons">Ειδοποιήσεις</ListItemText>
                {openFirstNested ? (
                  <ExpandLess className="WhiteIcons" />
                ) : (
                  <ExpandMore className="WhiteIcons" />
                )}
              </ListItem>

              <Collapse
                className="WhiteIcons"
                in={openFirstNested}
                timeout="auto"
                unmountOnExit
              >
                <List className="WhiteIcons" component="div" disablePadding>
                  <ListItem
                    button
                    className={classes.nested}
                    component={Link}
                    to="/open-alerts"
                  >
                    <Tooltip title="Ανοιχτές Ειδοποιήσεις">
                      <ListItemIcon className="WhiteIcons">
                        <Badge badgeContent={openCount} color="secondary">
                          <NotificationsIcon className="WhiteIcons" />
                        </Badge>
                      </ListItemIcon>
                    </Tooltip>
                    <ListItemText
                      className="WhiteIcons"
                      primary="Ανοιχτές Ειδοποιήσεις"
                    />
                  </ListItem>

                  <ListItem
                    button
                    className={classes.nested}
                    component={Link}
                    to="/assigned-alerts"
                  >
                    <Tooltip title="Ειδοποιήσεις σε εξέλιξη">
                      <ListItemIcon className="WhiteIcons">
                        <Badge badgeContent={pendingCount} color="secondary">
                          <NotificationsActiveIcon className="WhiteIcons" />
                        </Badge>
                      </ListItemIcon>
                    </Tooltip>
                    <ListItemText
                      className="WhiteIcons"
                      primary="Ειδοποιήσεις σε εξέλιξη"
                    />
                  </ListItem>

                  <ListItem
                    button
                    className={classes.nested}
                    component={Link}
                    to="/alerts-history"
                  >
                    <Tooltip title="Ιστορικό Ειδοποιήσεων">
                      <ListItemIcon>
                        <HistoryIcon className="WhiteIcons" />
                      </ListItemIcon>
                    </Tooltip>
                    <ListItemText
                      className="WhiteIcons"
                      primary="Ιστορικό Ειδοποιήσεων"
                    />
                  </ListItem>
                </List>
              </Collapse>

              {(roleDescription === "Admin" || roleDescription === "Power User") && <ListItem button component={Link} to="/end-user">
                <Tooltip title="Ωφελούμενοι">
                  <ListItemIcon>
                    <PersonAddIcon className="WhiteIcons" />
                  </ListItemIcon>
                </Tooltip>
                <ListItemText className="WhiteIcons">Ωφελούμενοι</ListItemText>
              </ListItem>}

              {(roleDescription === "Admin" ||
                roleDescription === "Power User") && (
                  <ListItem button onClick={handleSecondClick}>
                    <Tooltip title="Λίστες - Στατιστικά">
                      <ListItemIcon>
                        <AssessmentIcon className="WhiteIcons" />
                      </ListItemIcon>
                    </Tooltip>
                    <ListItemText className="WhiteIcons">
                      Λίστες - Στατιστικά
                  </ListItemText>
                    {openSecondNested ? (
                      <ExpandLess className="WhiteIcons" />
                    ) : (
                      <ExpandMore className="WhiteIcons" />
                    )}
                  </ListItem>
                )}
              {(roleDescription === "Admin" ||
                roleDescription === "Power User") && (
                  <Collapse in={openSecondNested} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {/* listes kai statistika */}
                      <ListItem
                        button
                        className={classes.nested}
                        component={Link}
                        to="/user-stats"
                      >
                        <Tooltip title="Χειριστών">
                          <ListItemIcon>
                            <Group className="WhiteIcons" />
                          </ListItemIcon>
                        </Tooltip>
                        <ListItemText
                          className="WhiteIcons"
                          primary="Χειριστών"
                        />
                      </ListItem>

                      <ListItem
                        button
                        className={classes.nested}
                        component={Link}
                        to="/alarm-stats"
                      >
                        <Tooltip title="Ειδοποιήσεων">
                          <ListItemIcon>
                            <Alarm className="WhiteIcons" />
                          </ListItemIcon>
                        </Tooltip>
                        <ListItemText
                          className="WhiteIcons"
                          primary="Ειδοποιήσεων"
                        />
                      </ListItem>
                    </List>
                  </Collapse>
                )}

              {roleDescription === "Admin" && (
                <ListItem button onClick={handleThirdClick}>
                  <Tooltip title="Παραμετροποίηση">
                    <ListItemIcon>
                      <SettingsIcon className="WhiteIcons" />
                    </ListItemIcon>
                  </Tooltip>
                  <ListItemText className="WhiteIcons">
                    Παραμετροποίηση
                  </ListItemText>
                  {openThirdNested ? (
                    <ExpandLess className="WhiteIcons" />
                  ) : (
                    <ExpandMore className="WhiteIcons" />
                  )}
                </ListItem>
              )}

              {roleDescription === "Admin" && (
                <Collapse in={openThirdNested} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItem
                      button
                      className={classes.nested}
                      onClick={() => {
                        handleFourthClick();
                        handleDrawerOpen();
                      }}
                    >
                      <Tooltip title="Διαχείριση Συσκευών">
                        <ListItemIcon>
                          <DeviceHubIcon className="WhiteIcons" />
                        </ListItemIcon>
                      </Tooltip>
                      <ListItemText
                        className="WhiteIcons"
                        primary="Διαχείριση Συσκευών"
                      />
                      {openFourthNested ? (
                        <ExpandLess className="WhiteIcons" />
                      ) : (
                        <ExpandMore className="WhiteIcons" />
                      )}
                    </ListItem>
                    <Collapse
                      in={openFourthNested}
                      timeout="auto"
                      unmountOnExit
                    >
                      <List component="div" disablePadding>
                        <ListItem
                          button
                          className={classes.secondLevelNested}
                          onClick={handleFifthClick}
                        >
                          <Tooltip title="Εξυπνη συσκευή">
                            <ListItemIcon>
                              <WatchIcon className="WhiteIcons" />
                            </ListItemIcon>
                          </Tooltip>
                          <ListItemText
                            className="WhiteIcons"
                            primary="Εξυπνη συσκευή"
                          />
                          {openFifthNested ? (
                            <ExpandLess className="WhiteIcons" />
                          ) : (
                            <ExpandMore className="WhiteIcons" />
                          )}
                        </ListItem>
                        <Collapse
                          in={openFifthNested}
                          timeout="auto"
                          unmountOnExit
                        >
                          <List component="div" disablePadding>
                            <ListItem
                              button
                              className={classes.thirdLevelNested}
                              component={Link}
                              to="/all-devices"
                            >
                              <Tooltip title="Όλες οι Συσκευές">
                                <ListItemIcon>
                                  <GroupWorkIcon className="WhiteIcons" />
                                </ListItemIcon>
                              </Tooltip>
                              <ListItemText
                                className="WhiteIcons"
                                primary="Όλες οι Συσκευές"
                              />
                            </ListItem>
                            <ListItem
                              button
                              className={classes.thirdLevelNested}
                              component={Link}
                              to="/initial-config"
                            >
                              <Tooltip title="Αρχικές Ρυθμίσεις">
                                <ListItemIcon>
                                  <SettingsApplicationsIcon className="WhiteIcons" />
                                </ListItemIcon>
                              </Tooltip>
                              <ListItemText
                                className="WhiteIcons"
                                primary="Αρχικές Ρυθμίσεις"
                              />
                            </ListItem>
                          </List>
                        </Collapse>
                      </List>
                    </Collapse>
                    <ListItem
                      button
                      className={classes.nested}
                      component={Link}
                      to="/risk-indicators"
                    >
                      <Tooltip title="Δείκτες Κινδύνων">
                        <ListItemIcon>
                          <SpeedIcon className="WhiteIcons" />
                        </ListItemIcon>
                      </Tooltip>
                      <ListItemText
                        className="WhiteIcons"
                        primary="Δείκτες Κινδύνων"
                      />
                    </ListItem>
                    <ListItem
                      button
                      className={classes.nested}
                      component={Link}
                      to="/alerts-status"
                    >
                      <Tooltip title="Καταστάσεις Ειδοποιήσεων">
                        <ListItemIcon>
                          <EditAttributesIcon className="WhiteIcons" />
                        </ListItemIcon>
                      </Tooltip>
                      <ListItemText
                        className="WhiteIcons"
                        primary="Καταστάσεις Ειδοποιήσεων"
                      />
                    </ListItem>

                    <ListItem
                      button
                      className={classes.nested}
                      component={Link}
                      to="/all-users"
                    >
                      <Tooltip title="Χειριστές">
                        <ListItemIcon>
                          <SupervisorAccountIcon className="WhiteIcons" />
                        </ListItemIcon>
                      </Tooltip>
                      <ListItemText
                        className="WhiteIcons"
                        primary="Χειριστές"
                      />
                    </ListItem>
                    <ListItem
                      button
                      className={classes.nested}
                      component={Link}
                      to="/user-logging"
                    >
                      <Tooltip title="Log Κινήσεων Ενεργειών Χειριστών">
                        <ListItemIcon>
                          <NotesIcon className="WhiteIcons" />
                        </ListItemIcon>
                      </Tooltip>
                      <ListItemText
                        className="WhiteIcons"
                        primary="Log Κινήσεων Ενεργειών Χειριστών"
                      />
                    </ListItem>
                  </List>
                </Collapse>
              )}
            </List>
            <Divider />
            <List>
              <ListItem button component={Link} to="/support">
                <Tooltip title="Βοήθεια">
                  <ListItemIcon>
                    <HelpIcon className="WhiteIcons" />
                  </ListItemIcon>
                </Tooltip>
                <ListItemText className="WhiteIcons">Βοήθεια</ListItemText>
              </ListItem>
            </List>
          </Drawer>
          <main className={classes.content}>
            <div className={classes.toolbar} />
            <AlertSnackbar />
            <Switch>
              <Route path="/maps" component={Maps} />

              <Route path="/risk-indicators" component={RiskIndicators} />

              <Route path="/open-alerts" component={OpenAlerts} />

              <Route path="/assigned-alerts" component={AssignedAlerts} />

              <Route path="/alerts-history" component={ClosedAlerts} />

              {(roleDescription === "Admin" || roleDescription === "Power User") && <Route path="/end-user" component={EndUsers} />}

              {roleDescription === "Admin" && (
                <Route path="/all-devices" component={Devices} />
              )}

              <Route path="/alerts-status" component={AlertsStatus} />

              {roleDescription === "Admin" && (
                <Route path="/all-users" component={ManagementUsers} />
              )}

              <Route path="/user-logging" component={UserLogging} />

              <Route path="/add-device" component={Device} />
              <Route path="/edit-device" component={Device} />

              <Route path="/add-end-user" component={AddEndUser} />
              <Route path="/edit-end-user" component={EditEndUser} />

              <Route path="/alert-take-over" component={AlertTakeOver} />

              <Route path="/smart-band-values" component={SmartBandValues} />




              {(roleDescription === "Admin" ||
                roleDescription === "Power User") && (
                  <Route path="/user-stats" component={UserStats} />
                )}
              {(roleDescription === "Admin" ||
                roleDescription === "Power User") && (
                  <Route path="/alarm-stats" component={AlarmStats} />
                )}
              {roleDescription === "Admin" && (
                <Route path="/initial-config" component={SmartBandValues} />
              )}

              {roleDescription === "Admin" && (
                <Route path="/create-user" component={CreateManagementUser} />
              )}
              {roleDescription === "Admin" && (
                <Route path="/print-form" component={PrintForm} />
              )}

              {roleDescription === "Admin" && (
                <Route
                  path="/edit-management-user"
                  component={EditManagementUser}
                />
              )}

              <Route path="/my-profile" component={MyProfile} />
              <Route
                path="/all-alerts-takeover"
                component={AllAlertsTakeOver}
              />
              <Route path="/last-known-location" component={LocationMap} />
              <Route path="/" component={Home} />
            </Switch>
          </main>
        </Router>
      </div>
    );
  } else {
    return <div></div>;
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.map,
    isAuth: state.auth.isAuth,
    openCount: state.counts.openCount,
    pendingCount: state.counts.pendingCount,
    reloadCountFlag: state.map.pointsStore,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    editMapState: (mapPayload) => {
      dispatch(actions.editMapState(mapPayload));
    },
    authorize: () => {
      dispatch(actions.authorizeValidation());
    },

    setOpenCount: (condition) => {
      dispatch(actions.setOpenCount(condition));
    },
    setPendingCount: (condition) => {
      dispatch(actions.setPendingCount(condition));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MiniDrawer);
